/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import "./Header.css";
import logo from "../../images/new_logo.png";
import default_pfp from "../../images/default_pfp.svg";
import { Link, useLocation } from "react-router-dom";
import { CommunityOwner, HomeOwner, Realtor, Vendor } from "../../Utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfileData } from "../../Services/Profile/ProfileApi";
import { setHeaderMessage } from "../../Services/DashboardHeader/uiSlice";
import { capitalizeFirstLetter } from "../../Utils/LetterCase";

function HeaderComponent() {
  const dispatch = useDispatch();
  const location = useLocation();
  const userType = localStorage.getItem("user_type");
  const firstName = localStorage.getItem("user_first_name");
  const lastName = localStorage.getItem("user_last_name");
  const [profile, setProfile] = useState({});
  const userTypeLabels = {
    [CommunityOwner]: "Admin",
    [Realtor]: "Realtor",
    [HomeOwner]: "Homeowner",
    [Vendor]: "Vendor",
  };
  const dashboardRoutes = {
    [CommunityOwner]: "/admin/Admin-community",
    [HomeOwner]: "/home-owner-admin/home-owner-community",
    [Realtor]: "/realtor/webcard",
    [Vendor]: "/vendor/subscription/advertisement-banner"
  };
  const profileRoutes = {
    [CommunityOwner]: "/admin/admin-profile",
    [HomeOwner]: "/home-owner-admin/homeowner-profile",
    [Realtor]: "/realtor/realtor-profile",
    [Vendor]: "/vendor/vendor-profile"
  };
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    dispatch(setHeaderMessage("Community Management"));
  };
  const { data } = useSelector((state) => state.fetchProfileData);

  const userId = localStorage.getItem("user_id")

  useEffect(() => {
    if (userId)
      dispatch(fetchProfileData(userId))
  }, [dispatch, userId]);

  useEffect(() => {
    if (data) {
      setProfile(data?.data);
    }
  }, [data]);
  return (
    <>
      <nav className="navbar navbar-expand-xl navbar-section">
        <div className="container-fluid">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-lg-0 navlist">
              <li className="nav-item">
                <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`}>
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/Hoa" className={`nav-link ${location.pathname === "/Hoa" ? "active" : ""}`}>
                  HOAs
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/compliance-and-resources" className={`nav-link ${location.pathname === "/compliance-and-resources" ? "active" : ""}`}>
                  Compliance
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/RealtorsBrokerages" className={`nav-link ${location.pathname === "/RealtorsBrokerages" ? "active" : ""}`}>
                  Realtors
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/Contact" className={`nav-link ${location.pathname === "/Contact" ? "active" : ""}`}>
                  Contact
                </Link>
              </li>
            </ul>
            {userId ?
              <div className="dropdown">
                <div
                  className="dropdown-toggle d-flex align-items-center gap-3 admin-profile-dropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="profile-picture-admin">
                    <img
                      src={profile?.image || default_pfp}
                      alt="Profile-picture"
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = default_pfp; // Fallback image
                      }}
                    />
                  </div>

                  <div className="admin-name-div">
                    {capitalizeFirstLetter(firstName) + " " + capitalizeFirstLetter(lastName)}
                    <span>
                      {userTypeLabels[userType] || "Vendor"}
                    </span>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to={dashboardRoutes[userType] || "/login"}
                      className="dropdown-item"
                    >
                      Go to dashboard
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={profileRoutes[userType] || "/login"}
                      onClick={() => dispatch(setHeaderMessage("Profile"))}
                      className="dropdown-item"
                    >
                      View Profile
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={handleLogout}
                      to="/"
                    >
                      Logout
                    </Link>
                  </li>
                </ul>
              </div> :
              <div className="d-flex login-content flex-column flex-xl-row">
                <Link to="/login" href="" className="Login-info">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    viewBox="0 0 19 20"
                    fill="#ffffff"
                  >
                    <g id="user-line">
                      <path
                        id="Vector"
                        d="M3.16666 17.9167C3.16666 14.4189 6.00218 11.5833 9.49999 11.5833C12.9978 11.5833 15.8333 14.4189 15.8333 17.9167H14.25C14.25 15.2933 12.1233 13.1667 9.49999 13.1667C6.87664 13.1667 4.74999 15.2933 4.74999 17.9167H3.16666ZM9.49999 10.7917C6.87561 10.7917 4.74999 8.66605 4.74999 6.04167C4.74999 3.4173 6.87561 1.29167 9.49999 1.29167C12.1244 1.29167 14.25 3.4173 14.25 6.04167C14.25 8.66605 12.1244 10.7917 9.49999 10.7917ZM9.49999 9.20834C11.2496 9.20834 12.6667 7.79126 12.6667 6.04167C12.6667 4.29209 11.2496 2.87501 9.49999 2.87501C7.75041 2.87501 6.33332 4.29209 6.33332 6.04167C6.33332 7.79126 7.75041 9.20834 9.49999 9.20834Z"
                        fill="#222222"
                      ></path>
                    </g>
                  </svg>
                  <span>
                    <a>Login</a>
                  </span>
                </Link>
                <Link to="/signupone">
                  <button className="btn btn-outline get-started gs-btn" type="submit">
                    Get Started{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="#222222"
                    >
                      <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                    </svg>
                  </button>
                </Link>
              </div>
            }
          </div>
        </div>
      </nav>
      {/* <section className='one'>
                <div className='container'>
                    <nav className="navbar navbar-expand-md navbar-section">
                        <div className="container-fluid">
                            <div className="logo">
                                <img src={logo} alt="logo"></img>
                            </div>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav mx-auto mb-lg-0 navlist">
                                    <li className="nav-item">
                                        <a className="nav-link" aria-current="page" href="#">Home</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="#">HOAs</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="#">Realtors & Brokerages</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="#">Contact</a>
                                    </li>
                                </ul>
                                <div className="d-flex login-content flex-column flex-md-row">
                                    <a href="" className='Login-info'><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 19 20" fill="#ffffff"><g id="user-line"><path id="Vector" d="M3.16666 17.9167C3.16666 14.4189 6.00218 11.5833 9.49999 11.5833C12.9978 11.5833 15.8333 14.4189 15.8333 17.9167H14.25C14.25 15.2933 12.1233 13.1667 9.49999 13.1667C6.87664 13.1667 4.74999 15.2933 4.74999 17.9167H3.16666ZM9.49999 10.7917C6.87561 10.7917 4.74999 8.66605 4.74999 6.04167C4.74999 3.4173 6.87561 1.29167 9.49999 1.29167C12.1244 1.29167 14.25 3.4173 14.25 6.04167C14.25 8.66605 12.1244 10.7917 9.49999 10.7917ZM9.49999 9.20834C11.2496 9.20834 12.6667 7.79126 12.6667 6.04167C12.6667 4.29209 11.2496 2.87501 9.49999 2.87501C7.75041 2.87501 6.33332 4.29209 6.33332 6.04167C6.33332 7.79126 7.75041 9.20834 9.49999 9.20834Z" fill="#222222"></path></g></svg><span> <Link to="/login">Login</Link></span></a>
                                    <button className="btn btn-outline get-started" type="submit">Get Started  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="#222222">
                                        <path d="M13.3364 7.84518L6.16426 15.0173L4.98575 13.8388L12.1579 6.66667H5.83643V5H15.0031V14.1667H13.3364V7.84518Z"></path>
                                    </svg></button>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
              </div>
            </div>
          </nav>
        </div>
        {/* </nav> */}
      {/* </div> */}
      {/* </section> */}
    </>
  );
}

export default HeaderComponent;
